exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.title-head[data-v-f3b88d6e]{margin-top: 0;\n}\n.terms-para[data-v-f3b88d6e]{padding-bottom:2rem;\n}\n.terms-para[data-v-f3b88d6e]:last-child{padding-bottom:0;\n}\n.terms-para *[data-v-f3b88d6e] {line-height:170%;\n}\n.terms-para ul[data-v-f3b88d6e]{padding-left:1rem;\n}\n.terms-para ul li[data-v-f3b88d6e]{list-style:decimal;padding:0 0 1rem .5rem;\n}\n.terms-para ul li[data-v-f3b88d6e]:last-child{padding-bottom:0;\n}\n.terms-para>p[data-v-f3b88d6e]{padding-bottom:1rem;\n}\n.terms-para>p[data-v-f3b88d6e]:last-child{padding-bottom:0;\n}\nh4.terms-title[data-v-f3b88d6e]{font-size:1rem;padding-bottom:1rem;color:#608197;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f3b88d6e","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Disclaimer.vue
// module id = +mWD
// module chunks = 2 3 4 5 6